import { MAX_USE_AMOUNT, MAX_USE_TICKETS } from "constants/discountConstants";
import { DiscountTypesEnum } from "helpers/constants";

export const getDiscountTypeOptions = (t: any) => {
  return [
    {
      value: DiscountTypesEnum.PERCENTAGE,
      label: t("form.create.percentage"),
    },
    {
      value: DiscountTypesEnum.SUBSTRACTION,
      label: t("form.create.amount"),
    },
  ];
};

export const getUsageLimitOptions = (t: any) => {
  return [
    {
      value: MAX_USE_TICKETS,
      label: t("form.create.maxUseTickets"),
    },
    {
      value: MAX_USE_AMOUNT,
      label: t("form.create.cumulativeAmount"),
    },
  ];
};
